import $ from 'jquery';
export default class CardButton {
    static mount() {
        $(function () {
            new CardButton();
        });
    }
    constructor() {
        this.$buttons = $('.wp-block-intas-card-button');
        this.registerObserver();
        this.$buttons.each((index, elem) => {
            const $button = $(elem);
            this.setTextShadow($button);
        });
    }
    updateSizes(entries) {
        for (let i = 0; i < entries.length; i++) {
            const $target = $(entries[i].target);
            const $group = $target.parents('.cardbutton-equal-height-group');
            const $buttons = $group.find('.wp-block-intas-card-button');
            let maxHeight = 0;
            for (let j = 0; j < $buttons.length; j++) {
                const $button = $($buttons[j]);
                let contentHeight = 0;
                const $a = $($button.children()[0]);
                for (let k = 0; k < $a.children().length; k++) {
                    let $child = $($a.children()[k]);
                    let outerHeight = $child.outerHeight(true);
                    if (outerHeight != undefined)
                        contentHeight += outerHeight;
                }
                let aOuterHeight = $a.outerHeight();
                if (aOuterHeight == undefined)
                    aOuterHeight = 0;
                let aHeight = $a.height();
                if (aHeight == undefined)
                    aHeight = 0;
                let aInnerHeight = $a.innerHeight();
                if (aInnerHeight == undefined)
                    aInnerHeight = 0;
                let aOuterHeightWithMargin = $a.outerHeight(true);
                if (aOuterHeightWithMargin == undefined)
                    aOuterHeightWithMargin = 0;
                var bordT = aOuterHeight - aInnerHeight;
                var paddT = aInnerHeight - aHeight;
                var margT = aOuterHeightWithMargin - aOuterHeight;
                contentHeight += bordT + paddT + margT;
                if (contentHeight != undefined && contentHeight > maxHeight) {
                    maxHeight = contentHeight;
                }
            }
            $buttons.css('height', maxHeight);
        }
    }
    registerObserver() {
        const that = this;
        const resizeObserver = new ResizeObserver((entries) => {
            that.updateSizes(entries);
        });
        this.$buttons.each((index, divElem) => {
            resizeObserver.observe(divElem);
        });
    }
    setTextShadow($button) {
        const color = $button.css('color');
        const invertedColor = this.getContrastColor(color);
        $button.css('text-shadow', `1px 1px 1px ${invertedColor}`);
    }
    getContrastColor(rgbColor) {
        const rgb = rgbColor.match(/\d+/g);
        const r = rgb && rgb[0] ? 255 - parseInt(rgb[0]) : 0;
        const g = rgb && rgb[1] ? 255 - parseInt(rgb[1]) : 0;
        const b = rgb && rgb[2] ? 255 - parseInt(rgb[2]) : 0;
        return `rgba(${r}, ${g}, ${b}, 0.5)`;
    }
}
